import {RegistrationSuccess} from "@/components/registration/RegistrationSuccess.jsx";
import RegistrationFailed from "@/components/registration/RegistrationFailed.jsx";

const RegistrationResult = ({ status, uuid, eventDetails, location }) => {
    const { name, selfiePreview } = location?.state || {};

    return (
        <div className="result-wrapper">
            {status === 'success' ? (
                <RegistrationSuccess
                    uuid={uuid}
                    eventDetails={eventDetails}
                    selfiePreview={selfiePreview}
                    name={name}
                />
            ) : (
                <RegistrationFailed uuid={uuid} selfiePreview={selfiePreview} />
            )}
        </div>
    );
};

export default RegistrationResult;